import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/motion';
type StatementSectionProps = {
  title: string;
  body: string;
  children?: React.ReactNode;
};
export function StatementSection({
  title,
  body,
  children
}: StatementSectionProps) {
  return <section className="bg-surface-bg border-t border-line py-20 lg:py-28" data-id="element-1429" data-mp="11ahafaxs2h3z">
      <motion.div {...fadeUp} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-1430" data-mp="118d82xfj1q5t">
        <h2 className="lg:col-span-5 font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight" data-id="element-1431" data-mp="1tzeof1uyhrqx">
          {title}
        </h2>
        <div className="lg:col-span-7" data-id="element-1432" data-mp="1f48h8bk4jmw0">
          <p className="font-heading font-semibold text-xl lg:text-2xl text-ink-dark leading-relaxed border-l-4 border-teal pl-6" data-id="element-1433" data-mp="1k05xyizauv9b">
            {body}
          </p>
          {children}
        </div>
      </motion.div>
    </section>;
}